export default __webpack_public_path__ + "static/media/4b.7f1ef1c5.png";